import {useSelector} from 'react-redux';
import {activeItemSelector, savingSelector} from '../store';

export function useActiveItem() {
  const activeItem = useSelector(activeItemSelector);
  const saving = useSelector(savingSelector);

  return {item: activeItem, saving};
}
